import { makeAutoObservable } from "mobx";

export type WaveformProgressEntry = {
  trackId: string;
  peaks: Float32Array;
  durationSec: number;
  processedUntilSec: number;
  version: number;
};

class WaveformProgressStoreImpl {
  byTrackId = new Map<string, WaveformProgressEntry>();
  version = 0;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  updateProgress(params: {
    trackId: string;
    peaks: Float32Array;
    durationSec: number;
    processedUntilSec: number;
  }) {
    const trackId = String(params.trackId || "");
    if (!trackId) return;

    const durationSec = Number(params.durationSec ?? 0);
    const processedUntilSec = Math.max(0, Number(params.processedUntilSec ?? 0));
    const peaks = params.peaks;
    if (!(peaks instanceof Float32Array) || peaks.length === 0) return;

    const prev = this.byTrackId.get(trackId);
    const nextVersion = (prev?.version ?? 0) + 1;

    this.byTrackId.set(trackId, {
      trackId,
      peaks,
      durationSec,
      processedUntilSec,
      version: nextVersion,
    });
    this.version++;
  }

  clear(trackId: string | null | undefined) {
    const id = String(trackId || "");
    if (!id) return;
    if (!this.byTrackId.has(id)) return;
    this.byTrackId.delete(id);
    this.version++;
  }

  get(trackId: string | null | undefined): WaveformProgressEntry | null {
    const id = String(trackId || "");
    if (!id) return null;
    return this.byTrackId.get(id) ?? null;
  }
}

export const WaveformProgressStore = new WaveformProgressStoreImpl();

